import { instanceToPlain } from 'class-transformer'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { FieldData } from '../components/Pi/types'

@Component
export default class ModelSetter extends Vue {
  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => {
      this.$set(arg.model, arg.key, val)
    }
    return arg
  }

  messageEditorToPlainSetter(arg: FieldData):FieldData {
    arg.setter = (value) => {
      this.$set(arg.model, arg.key, instanceToPlain(value))
    }

    return arg
  }
}
